import Vue from "vue";
import Vuex from "vuex";

const State = {
    namespaced: true,
    state: {
        states: [],
    },
    actions : {
        getStates(context){
            return new Promise((resolve, reject) => {
                Vue.axios.get(window.urlapi + "state").then(
                    response => {
                        context.commit("GETSTATES", response.data.data);
                        resolve(response.data.data);
                    },
                );
            })
        },
    },
    mutations: {
        GETSTATES: (state, states) => {
            state.states = states;
        },
    },
    getters: {
        states: state => {
            return state.states;
        },
    },
    modules: {}
};

export default State;
